class LoveCalculator {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    if (!this.modal) {
      console.log('[LoveCalculator] Modal not found:', modalId);
      return;
    }

    this.STORAGE_KEY = 'ghar_love_calculator_data';
    this.GLOBAL_POPUP_SHOWN_KEY = 'ghar_love_calculator_global_shown';
    this.currentDecodedCoupon = '';
    this.popupMode = this.modal.getAttribute('data-popup-mode') || 'none';

    console.log('[LoveCalculator] Initialized with mode:', this.popupMode);

    this.cacheDOM();
    this.initDiscountData();
    this.initModal();
    this.bindEvents();
    this.initFloatingButton();
    this.initGlobalPopup();
  }

  // ==========================================
  // Global Welcome Popup Logic
  // ==========================================

  initGlobalPopup() {
    console.log('[LoveCalculator] initGlobalPopup - mode:', this.popupMode);

    // Only trigger if mode is 'global'
    if (this.popupMode !== 'global') {
      console.log('[LoveCalculator] Not global mode, skipping');
      return;
    }

    // Check if popup was already shown in this session
    var alreadyShown = sessionStorage.getItem(this.GLOBAL_POPUP_SHOWN_KEY);
    if (alreadyShown) {
      console.log('[LoveCalculator] Already shown this session, showing floating button');
      // Show floating button if user has already seen popup
      this.showFloatingButton();
      return;
    }

    console.log('[LoveCalculator] Will show popup in 3 seconds...');

    // Show popup after 3 seconds
    var self = this;
    setTimeout(function() {
      console.log('[LoveCalculator] Timer fired, opening popup...');
      self.openGlobalPopup();
    }, 3000);
  }

  openGlobalPopup() {
    console.log('[LoveCalculator] openGlobalPopup called');

    // Mark as shown for this session
    sessionStorage.setItem(this.GLOBAL_POPUP_SHOWN_KEY, 'true');

    // Open modal and check for existing result
    this.openModalWithResult();
  }

  // ==========================================
  // Floating Button (Global Mode Only)
  // ==========================================

  initFloatingButton() {
    this.floatingBtn = document.getElementById('lcFloatingBtn');
    if (!this.floatingBtn) return;

    var self = this;
    this.floatingBtn.addEventListener('click', function() {
      self.openModalWithResult();
    });
  }

  showFloatingButton() {
    if (this.floatingBtn) {
      this.floatingBtn.classList.remove('hidden');
    }
  }

  hideFloatingButton() {
    if (this.floatingBtn) {
      this.floatingBtn.classList.add('hidden');
    }
  }

  // ==========================================
  // Open Modal with Existing Result (if any)
  // ==========================================

  openModalWithResult() {
    // Check if there's existing result data
    var storedData = this.getStoredData();

    if (storedData && storedData.yourName && storedData.partnerName) {
      console.log('[LoveCalculator] Found existing result, showing result view');
      // Show result directly without animation
      this.showResult(
        storedData.yourName,
        storedData.partnerName,
        storedData.percentage,
        storedData.coupon,
        false // no animation
      );
    } else {
      console.log('[LoveCalculator] No existing result, showing form');
      // Reset to form view
      this.resetToFormView();
    }

    // Open the modal
    this.openModalManually();
  }

  resetToFormView() {
    this.resultView.classList.add('hidden');
    this.formView.style.display = 'block';
    if (this.contentWrapper) this.contentWrapper.classList.remove('lc-result-active');
    this.lovePercentage.textContent = '0%';
    this.resetHeartFill();
    if (this.couponInfoSection) this.couponInfoSection.classList.add('hidden');
    if (this.couponBoxSection) this.couponBoxSection.classList.add('hidden');
    if (this.playAgainSection) this.playAgainSection.classList.add('hidden');
  }

  openModalManually() {
    var self = this;
    this.modal.classList.add('modal--is-active');
    document.documentElement.classList.add('modal-open');
    document.body.classList.add('modal-open');

    // Hide floating button when modal is open
    this.hideFloatingButton();

    // Bind close handlers for manual open
    var closeModal = function(e) {
      var target = e.target;
      // Close if clicking on overlay background (the modal itself, not inner content)
      var isOverlayClick = target === self.modal;
      var isCloseWrapper = target.classList.contains('close-icon-wrapper') || target.closest('.close-icon-wrapper');
      var isCloseBtn = target.classList.contains('js-modal-close') || target.closest('.js-modal-close');

      if (isOverlayClick || isCloseWrapper || isCloseBtn) {
        e.preventDefault();
        e.stopPropagation();
        self.closeModalManually();
      }
    };

    // Add click listener for closing
    this.modal.addEventListener('click', closeModal);

    // Store reference to remove later
    this._manualCloseHandler = closeModal;
  }

  closeModalManually() {
    this.modal.classList.remove('modal--is-active');
    document.documentElement.classList.remove('modal-open');
    document.body.classList.remove('modal-open');

    // Show floating button after closing (only for global mode)
    if (this.popupMode === 'global') {
      this.showFloatingButton();
    }

    // Remove the click listener
    if (this._manualCloseHandler) {
      this.modal.removeEventListener('click', this._manualCloseHandler);
      this._manualCloseHandler = null;
    }
  }

  cacheDOM() {
    this.contentWrapper = this.modal.querySelector('.modal__centered');
    this.formView = this.modal.querySelector('#loveCalculatorForm');
    this.resultView = this.modal.querySelector('#loveCalculatorResult');
    this.revealBtn = this.modal.querySelector('#revealLoveMagic');
    this.playAgainBtn = this.modal.querySelector('#playAgain');
    this.copyBtn = this.modal.querySelector('#copyCoupon');
    this.yourNameInput = this.modal.querySelector('#yourName');
    this.partnerNameInput = this.modal.querySelector('#partnerName');

    this.resultYourName = this.modal.querySelector('#resultYourName');
    this.resultPartnerName = this.modal.querySelector('#resultPartnerName');
    this.lovePercentage = this.modal.querySelector('#lovePercentage');
    this.discountAmount = this.modal.querySelector('#discountAmount');
    this.couponCode = this.modal.querySelector('#couponCode');
    this.couponInfoSection = this.modal.querySelector('#couponInfoSection');
    this.couponBoxSection = this.modal.querySelector('#couponBoxSection');
    this.playAgainSection = this.modal.querySelector('#playAgainSection');
    this.heartFillRect = this.modal.querySelector('#heartFillRect');
    this.closeBtn = this.modal.querySelector('.js-modal-close');
  }

  initDiscountData() {
    var encoded = this.modal.getAttribute('data-discount-data') || '';
    var decoded = '';
    try { decoded = atob(encoded); } catch (e) { decoded = ''; }

    this.discountTiers = decoded.split(',').map(function(tier) {
      var parts = tier.split(':');
      return { percentage: parseInt(parts[0], 10), code: parts[1] };
    }).filter(function(tier) {
      return !isNaN(tier.percentage) && tier.code;
    });

    this.discountPercentages = this.discountTiers.map(function(t) { return t.percentage; });
    this.discountCodes = this.discountTiers.map(function(t) { return t.code; });
  }

  initModal() {
    if (typeof theme !== 'undefined' && theme.Modals) {
      this.themeModal = new theme.Modals('LoveCalculatorPopup', 'love-calculator');
    }
  }

  // ==========================================
  // Event Binding
  // ==========================================

  bindEvents() {
    var self = this;

    if (this.revealBtn) {
      this.revealBtn.addEventListener('click', this.handleReveal.bind(this));
    }
    if (this.playAgainBtn) {
      this.playAgainBtn.addEventListener('click', this.handlePlayAgain.bind(this));
    }
    if (this.copyBtn) {
      this.copyBtn.addEventListener('click', this.handleCopy.bind(this));
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function() {
        self.closeModalManually();
      });
    }

    // Handle theme modal close event
    this.modal.addEventListener('modalClose', function() {
      if (self.popupMode === 'global') {
        self.showFloatingButton();
      }
    });

    // For PDP mode: Handle trigger button click to show existing result
    if (this.popupMode === 'pdp') {
      var triggerBtn = document.querySelector('.js-modal-open-love-calculator');
      if (triggerBtn) {
        triggerBtn.addEventListener('click', function(e) {
          e.preventDefault();
          self.openModalWithResult();
        });
      }
    }
  }

  // ==========================================
  // Storage
  // ==========================================

  getStoredData() {
    try {
      var data = localStorage.getItem(this.STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      return null;
    }
  }

  saveData(yourName, partnerName, percentage, coupon) {
    try {
      var data = {
        yourName: yourName,
        partnerName: partnerName,
        percentage: percentage,
        coupon: coupon,
        timestamp: Date.now()
      };
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving love calculator data:', e);
    }
  }

  namesMatch(name1, name2) {
    var stored = this.getStoredData();
    if (!stored) return false;
    return stored.yourName.toLowerCase().trim() === name1.toLowerCase().trim() &&
           stored.partnerName.toLowerCase().trim() === name2.toLowerCase().trim();
  }

  getExistingResult(name1, name2) {
    if (this.namesMatch(name1, name2)) return this.getStoredData();
    return null;
  }

  // ==========================================
  // Love Score Calculation (Weighted Probability)
  // ==========================================

  generateNameHash(name1, name2) {
    var combined = (name1 + name2).toLowerCase().replace(/\s/g, '');
    var hash = 0;
    for (var i = 0; i < combined.length; i++) {
      var char = combined.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash);
  }

  calculateLoveScore(name1, name2) {
    var hash = this.generateNameHash(name1, name2);

    // Separate tiers into LOW (≤60%) and HIGH (>60%)
    var lowTiers = [];
    var highTiers = [];

    for (var i = 0; i < this.discountTiers.length; i++) {
      var tier = this.discountTiers[i];
      if (tier.percentage <= 60) {
        lowTiers.push(tier);
      } else {
        highTiers.push(tier);
      }
    }

    // Weighted probability: 80% chance for LOW, 20% chance for HIGH
    var probabilityCheck = hash % 100;
    var selectedTier;

    if (probabilityCheck < 80) {
      // 80% chance - Pick from LOW tiers (≤60%)
      if (lowTiers.length > 0) {
        var lowIndex = hash % lowTiers.length;
        selectedTier = lowTiers[lowIndex];
      } else {
        // Fallback if no low tiers configured
        var index = hash % this.discountTiers.length;
        selectedTier = this.discountTiers[index];
      }
    } else {
      // 20% chance - Pick from HIGH tiers (>60%)
      if (highTiers.length > 0) {
        var highIndex = hash % highTiers.length;
        selectedTier = highTiers[highIndex];
      } else {
        // Fallback if no high tiers configured
        var index = hash % this.discountTiers.length;
        selectedTier = this.discountTiers[index];
      }
    }

    return {
      percentage: selectedTier.percentage,
      coupon: selectedTier.code
    };
  }

  // ==========================================
  // Heart Fill Animation
  // ==========================================

  updateHeartFill(percent) {
    if (!this.heartFillRect) return;
    var fillHeight = (percent / 100) * 32;
    var yPos = 32 - fillHeight;
    this.heartFillRect.setAttribute('y', yPos.toString());
    this.heartFillRect.setAttribute('height', fillHeight.toString());
  }

  resetHeartFill() {
    if (!this.heartFillRect) return;
    this.heartFillRect.setAttribute('y', '32');
    this.heartFillRect.setAttribute('height', '0');
  }

  animatePercentage(targetPercent) {
    var self = this;
    var current = 0;
    var duration = 1500;
    var increment = targetPercent / (duration / 16);

    var timer = setInterval(function() {
      current += increment;
      if (current >= targetPercent) {
        current = targetPercent;
        clearInterval(timer);

        if (self.couponInfoSection) self.couponInfoSection.classList.remove('hidden');
        if (self.couponBoxSection) self.couponBoxSection.classList.remove('hidden');
        if (self.playAgainSection) self.playAgainSection.classList.remove('hidden');
      }
      self.lovePercentage.textContent = Math.round(current) + '%';
      self.updateHeartFill(current);
    }, 16);
  }

  // ==========================================
  // UI: Show Result
  // ==========================================

  showResult(yourName, partnerName, percentage, coupon, animate) {
    this.currentDecodedCoupon = coupon;

    this.resultYourName.textContent = yourName;
    this.resultPartnerName.textContent = partnerName;
    this.discountAmount.textContent = '\u20B9' + percentage + ' OFF';
    this.couponCode.textContent = coupon;

    this.lovePercentage.textContent = animate ? '0%' : percentage + '%';

    if (animate) {
      this.resetHeartFill();
    } else {
      this.updateHeartFill(percentage);
    }

    if (animate) {
      if (this.couponInfoSection) this.couponInfoSection.classList.add('hidden');
      if (this.couponBoxSection) this.couponBoxSection.classList.add('hidden');
      if (this.playAgainSection) this.playAgainSection.classList.add('hidden');
    } else {
      if (this.couponInfoSection) this.couponInfoSection.classList.remove('hidden');
      if (this.couponBoxSection) this.couponBoxSection.classList.remove('hidden');
      if (this.playAgainSection) this.playAgainSection.classList.remove('hidden');
    }

    this.formView.style.display = 'none';
    this.resultView.classList.remove('hidden');
    if (this.contentWrapper) this.contentWrapper.classList.add('lc-result-active');

    if (animate) {
      var self = this;
      setTimeout(function() { self.animatePercentage(percentage); }, 200);
    }
  }

  // ==========================================
  // Event Handlers
  // ==========================================

  handleReveal() {
    var yourName = this.yourNameInput.value.trim();
    var partnerName = this.partnerNameInput.value.trim();
    var hasError = false;

    if (!yourName) {
      this.yourNameInput.style.boxShadow = '0 0 0 2px #e91e63';
      setTimeout(function() { this.yourNameInput.style.boxShadow = ''; }.bind(this), 2000);
      hasError = true;
    }

    if (!partnerName) {
      this.partnerNameInput.style.boxShadow = '0 0 0 2px #e91e63';
      setTimeout(function() { this.partnerNameInput.style.boxShadow = ''; }.bind(this), 2000);
      hasError = true;
    }

    if (hasError) {
      if (!yourName) { this.yourNameInput.focus(); }
      else { this.partnerNameInput.focus(); }
      return;
    }

    var existingResult = this.getExistingResult(yourName, partnerName);

    if (existingResult) {
      this.showResult(yourName, partnerName, existingResult.percentage, existingResult.coupon, true);
    } else {
      var result = this.calculateLoveScore(yourName, partnerName);
      this.saveData(yourName, partnerName, result.percentage, result.coupon);
      this.showResult(yourName, partnerName, result.percentage, result.coupon, true);
    }
  }

  handlePlayAgain() {
    this.lovePercentage.textContent = '0%';
    this.resetHeartFill();

    if (this.couponInfoSection) this.couponInfoSection.classList.add('hidden');
    if (this.couponBoxSection) this.couponBoxSection.classList.add('hidden');
    if (this.playAgainSection) this.playAgainSection.classList.add('hidden');

    this.resultView.classList.add('hidden');
    this.formView.style.display = 'block';
    if (this.contentWrapper) this.contentWrapper.classList.remove('lc-result-active');
    this.yourNameInput.value = '';
    this.partnerNameInput.value = '';
    this.yourNameInput.focus();
  }

  handleCopy() {
    var code = this.currentDecodedCoupon;
    if (!code) return;

    var self = this;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function() {
        self.showCopiedFeedback();
      }).catch(function() {
        self.fallbackCopy(code);
      });
    } else {
      this.fallbackCopy(code);
    }
  }

  fallbackCopy(text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      this.showCopiedFeedback();
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    document.body.removeChild(textarea);
  }

  showCopiedFeedback() {
    var originalText = this.copyBtn.innerHTML;
    this.copyBtn.classList.add('copied');
    this.copyBtn.innerHTML = 'Copied!';

    var self = this;
    setTimeout(function() {
      self.copyBtn.classList.remove('copied');
      self.copyBtn.innerHTML = originalText;
    }, 2500);
  }

  resetToInitialState() {
    this.resultView.classList.add('hidden');
    this.formView.style.display = 'block';
    if (this.contentWrapper) this.contentWrapper.classList.remove('lc-result-active');
    this.lovePercentage.textContent = '0%';
    this.resetHeartFill();
    this.yourNameInput.value = '';
    this.partnerNameInput.value = '';
    this.yourNameInput.style.boxShadow = '';
    this.partnerNameInput.style.boxShadow = '';
    this.currentDecodedCoupon = '';
    if (this.couponInfoSection) this.couponInfoSection.classList.add('hidden');
    if (this.couponBoxSection) this.couponBoxSection.classList.add('hidden');
    if (this.playAgainSection) this.playAgainSection.classList.add('hidden');
  }
}

// Initialize when DOM is ready
(function() {
  function init() {
    new LoveCalculator('LoveCalculatorPopup');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
